export default (settings: any) => settings['entities'] * (1 / 60) * 30
